import request from '@/utils/request'


// 获取类型，中心 ，详情
// 客户案例首页 
export function homeCustomer (data) {
  return request({
    url: '/CustomerCaseApi/CustomerCaseIndex',
    method: 'post',
    data
  })
}
// 客户案例中心
export function customerCase(data) {
  return request({
    url: '/CustomerCaseApi/Index',
    method: 'post',
    data
  })
}
// 获取客户案例类型
export function customerCaseType (data) {
  return request({
    url: 'CustomerCaseApi/CustomerCaseTypeIndex',
    method: 'post',
    data
  })
}
// 客户案例详情 
export function customerCaseInfo (data) {
  return request({
    url: '/CustomerCaseApi/Show',
    method: 'post',
    data
  })
}